import { Injectable } from '@angular/core';
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { ComponentType } from '@angular/cdk/overlay';
import { ContactAgentComponent } from '../component/modals/contact-agent/contact-agent.component';
import { HighRiskComponent } from '../component/modals/high-risk/high-risk.component';
import { GdprComponent } from '../component/modals/gdpr/gdpr.component';
import { ConclusionRemoteComponent } from '../component/modals/conclusion-remote/conclusion-remote.component';
import { ChangePremiumComponent } from '../component/modals/change-premium/change-premium.component';
import { CustomizeAlcoholComponent } from '../component/modals/customize-alcohol/customize-alcohol.component';
import { CompareOffersComponent } from '../component/modals/compare-offers/compare-offers.component';
import { LeisureSportsComponent } from '../component/modals/leisure-sports/leisure-sports.component';
import { ResignationCancelComponent } from '../component/modals/resignation-cancel/resignation-cancel.component';
import { ResignationInterruptComponent } from '../component/modals/resignation-interrup/resignation-interrupt.component';
import { TrackingService } from '../tracking/tracking.service';
import { InsuredImportComponent } from '../component/modals/insured-import/insured-import.component';
import { OfferLeafletComponent } from '../component/modals/offer-leaflet/offer-leaflet.component';
import { CustomizeForTheActiveComponent } from '../component/modals/customioze-for-the-active/customize-for-the-active.component';

export enum ModalType {
  ContactAgent = 'contact-agent',
  HighRisk = 'high-risk',
  LeisureSports = 'leisure-sports',
  GDPR = 'gdpr',
  ConclusionRemote = 'conclusion-remote',
  ChangePremium = 'change-premium',
  CustomizeAlcohol = 'customize-alcohol',
  CustomizeForTheActive = 'customize-for-the-active',
  CompareOffers = 'compare-offers',
  ResignationInterrupt = 'resignation-interrupt',
  ResignationCancel = 'resignation-cancel',
  InsuredImport = 'insured-import',
  OfferLeaflet = 'offer-leaflet',
}

type ModalComponents =
  | ContactAgentComponent
  | HighRiskComponent
  | LeisureSportsComponent
  | GdprComponent
  | ConclusionRemoteComponent
  | ChangePremiumComponent
  | CustomizeAlcoholComponent
  | CompareOffersComponent
  | ResignationCancelComponent
  | ResignationInterruptComponent
  | InsuredImportComponent
  | OfferLeafletComponent;
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private dialogService: NxDialogService, private trackingService: TrackingService) {}

  openModal(type: ModalType, options?: Record<string, any>) {
    this.trackingService.openModal(type);

    let componentToOpen: ComponentType<ModalComponents>;

    switch (type) {
      case ModalType.ContactAgent:
        componentToOpen = ContactAgentComponent;
        break;
      case ModalType.HighRisk:
        componentToOpen = HighRiskComponent;
        break;
      case ModalType.LeisureSports:
        componentToOpen = LeisureSportsComponent;
        break;
      case ModalType.GDPR:
        componentToOpen = GdprComponent;
        break;
      case ModalType.ConclusionRemote:
        componentToOpen = ConclusionRemoteComponent;
        break;
      case ModalType.ChangePremium:
        componentToOpen = ChangePremiumComponent;
        break;
      case ModalType.CustomizeAlcohol:
        componentToOpen = CustomizeAlcoholComponent;
        break;
      case ModalType.CompareOffers:
        componentToOpen = CompareOffersComponent;
        break;
      case ModalType.ResignationCancel:
        componentToOpen = ResignationCancelComponent;
        break;
      case ModalType.ResignationInterrupt:
        componentToOpen = ResignationInterruptComponent;
        break;
      case ModalType.InsuredImport:
        componentToOpen = InsuredImportComponent;
        break;
      case ModalType.OfferLeaflet:
        componentToOpen = OfferLeafletComponent;
        break;
      case ModalType.CustomizeForTheActive:
        componentToOpen = CustomizeForTheActiveComponent;
    }

    this.dialogService.open(componentToOpen, this.getConfig(type, options));
  }

  closeModalAll() {
    this.dialogService.closeAll();
  }

  private getConfig(type: ModalType, options?: Record<string, any>) {
    switch (type) {
      case ModalType.GDPR:
        return {
          panelClass: `${type}-modal`,
          showCloseIcon: true,
          maxWidth: '736px',
          width: '100%',
          ...options,
        };
      default:
        return {
          panelClass: `${type}-modal`,
          showCloseIcon: true,
          maxWidth: '900px',
          width: '100%',
          maxHeight: '80vh',
          ...options,
        };
    }
  }
}
